export default "__VITE_ASSET__bMPQuERh__"